import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';

import nlLocale from '@/utils/localization/nlLocale.json';

i18n.use(initReactI18next);

void i18n.init({
	resources: {
		nl: {
			translation: {
				...nlLocale,
			},
		},
	},
	supportedLngs: ['nl'],
	lng: 'nl',
	fallbackLng: 'nl',
	interpolation: {
		escapeValue: false,
	},
	returnEmptyString: false,
});

export default i18n;
